import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Tag } from '@/components/ui/tag';
import { ExternalConnectionDto } from '@/lib/integrationTypes/externalConnectionTypes';
import DeleteConnectionModel from './DeleteConnectionModel';
import { useMemo } from 'react';
import { basicConnectionHealthCheck, HealthCheckColours } from '../connectionHealthCheck';
import { Mail, Siren, Webhook, Wrench } from 'lucide-react';

export interface ConnectionSidebarProps {
  externalConnection: ExternalConnectionDto;
}

export default function ConnectionSidebar({ externalConnection }: ConnectionSidebarProps) {
  const healthChecks = useMemo(
    () => basicConnectionHealthCheck(externalConnection),
    [externalConnection]
  );

  return (
    <>
      <div>
        <div className="sticky top-[7.1rem] min-h-[calc(100vh-7.1rem)] border-l bg-[#111]">
          <section className=" ">
            <div className="flex items-center justify-between border-b p-4">
              <h2 className="font-semibold">Device Health</h2> <Tag variant="success">0 Issues</Tag>
            </div>
            <div className="">
              <ul className="">
                {healthChecks?.map((check, index) => (
                  <li
                    className="flex items-center justify-between border-b border-[#222826] p-4"
                    key={index}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`ml-1 h-2 w-2 rounded-full ${HealthCheckColours[check.status]}`}
                      ></div>
                      <span className="text-sm">{check.key}</span>
                    </div>
                    <span className="text-sm">{check.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>
          <section className="h-fit">
            <h2 className="border-b border-t p-4 font-semibold">Supported capabilities</h2>
            <div className="p-4">
              <ul className="space-y-3 text-sm">
                {externalConnection.integration.smtpSource && (
                  <li className="flex items-center gap-2">
                    <Mail className="h-5 w-5 text-lime" />
                    <span>SMTP Events</span>
                  </li>
                )}
                {externalConnection.integration.webhookSource && (
                  <li className="flex items-center gap-2">
                    <Webhook className="h-5 w-5 text-lime" />
                    <span>Webhook Events</span>
                  </li>
                )}
                {externalConnection.integration.watchfulLifecycleTrigger && (
                  <li className="flex items-center gap-2">
                    <Siren className="h-5 w-5 text-lime" />
                    <span>Watchful Lifecycle Events</span>
                  </li>
                )}
                <li className="flex items-center gap-2">
                  <Wrench className="h-5 w-5 text-lime" />
                  <span>Automatic Ingestion</span>
                </li>
              </ul>
            </div>
            <div className="border-t p-4">
              <Button className="w-full" variant="outline">
                Request more features
              </Button>
            </div>
          </section>
          <section className="sticky top-[100vh] border-t">
            {externalConnection && externalConnection.id && (
              <Accordion type="single" collapsible>
                <AccordionItem value="danger-zone" className="border-none">
                  <AccordionTrigger className="border-b p-4 text-xs font-semibold text-lime">
                    Danger Zone
                  </AccordionTrigger>
                  <AccordionContent className="p-4">
                    <DeleteConnectionModel
                      id={externalConnection.id}
                      deviceData={externalConnection}
                    />
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            )}
          </section>
        </div>
      </div>
    </>
  );
}
